import { useTranslation } from 'react-i18next';
import { useNavigate } from 'raviger';
import { Box, Button, Typography, Card, Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Animated } from 'react-animated-css';

import appBG from '../../assets/appBG.jpg';
import line from '../../assets/line.svg';
import zofimMobile from '../../assets/zofimMobile.svg';
import mobileAndChild from '../../assets/mobileAndChild.svg';

const useStyles = makeStyles(() => ({
    background: {
        backgroundImage: `url(${appBG})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        minHeight: "100vh"
    },
    buttonGreen: {
        color: '#3a7735 !important',
        fontSize: '1.2rem !important',
        fontWeight: 'bold !important',
        backgroundColor: '#ffffff !important',
        borderRadius: '2rem !important',
        boxShadow: '0 8px 9px rgb(125 125 125 / 40%)',
        textTransform: "capitalize !important",
        width: "15rem !important",
        border: "1px solid !important",
        marginTop: "1.5rem !important"
    },
    card: {
        alignItems: 'center !important',
        height: '22rem !important',
        width: '20rem !important',
        borderRadius: '20px !important',
    },
    text: {
        color: '#3a7735 !important',
        fontWeight: "bold !important"
    }
}));

const Auth0ConfirmEmailPage = ({ verified = true }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" className={classes.background}>
            {verified ? (
                <>
                    <Animated animationIn="fadeIn" animationInDuration={1200} isVisible={true}>
                        <Typography sx={{ color: "#ffffff", fontSize: "1.3rem" }}>
                            {t("confirmSuccess")}
                        </Typography>
                    </Animated>
                    <Animated animationIn="slideInUp" animationInDuration={1200} isVisible={true}>
                        <img
                            style={{ marginTop: "1rem", paddingLeft: "1.5rem" }}
                            width="fit-content"
                            height="auto"
                            alt="success"
                            src={mobileAndChild}
                        />
                    </Animated>
                    <Animated animationIn="slideInUp" animationInDuration={1200} animationInDelay={1202} isVisible={true}>
                        <img style={{ marginTop: "1rem" }} alt="line" src={line} />
                    </Animated>
                    <Animated animationIn="fadeIn" animationInDuration={1200} animationInDelay={1204} isVisible={true}>
                        <Typography sx={{ color: "#ffffff", fontSize: "1.3rem" }}>
                            {t("nowGoBack")}
                        </Typography>
                    </Animated>
                    <Animated animationIn="slideInUp" animationInDuration={1200} animationInDelay={1202} isVisible={true}>
                        <img style={{ marginTop: "1rem" }} alt="mobile" src={zofimMobile} />
                    </Animated>
                    <Animated animationIn="slideInUp" animationInDuration={1200} animationInDelay={2405} isVisible={true}>
                        <img style={{ marginTop: "1rem" }} alt="line" src={line} />
                    </Animated>
                    <Animated animationIn="fadeIn" animationInDuration={1200} animationInDelay={2405} isVisible={true}>
                        <Typography sx={{ color: "#ffffff", fontSize: "1.3rem" }}>
                            {t("continueReg")}
                        </Typography>
                    </Animated>
                    <Animated animationIn="fadeIn" animationInDuration={700} animationInDelay={3600} isVisible={true}>
                        <Button className={classes.buttonGreen} onClick={() => navigate("/")}>
                            {t("backToLogin1")}
                        </Button>
                    </Animated>
                </>
            ) : (
                <Card className={classes.card}>
                    <Container sx={{ marginTop: "1rem", padding: "1.5rem !important", textAlign: "center" }}>
                        <Typography className={classes.text}>{t("expLink")}</Typography>
                        <Typography className={classes.text}>{t("expLink1")}</Typography>
                        <Button className={classes.buttonGreen} onClick={() => navigate("/")}>
                            {t("backToLogin1")}
                        </Button>
                    </Container>
                </Card>
            )}
        </Box>
    );
};

export default Auth0ConfirmEmailPage;